import { Theme } from "common";
export const facultyDetailsStyles = {
  actionButton: {
    padding: "5px 0px 0px 0px",
    "& .MuiIconButton-root": {
      fontSize: "0.5rem",
    },
  },
  actionContent: {
    display: "flex",
  },
  hideVisibility: {
    visibility: "hidden",
  },
  noData: {
    textAlign: "center",
    color: Theme.palette.grey[500],
  },
  collapseWidth: {
    width: "92%",
  },
  collapseIcon: {
    padding: "0px 0px 2px 0px",
  },
  collapseRowBackgroundColor: {
    backgroundColor: Theme.palette.primary.light,
    "& .MuiTableCell-head": {
      color: Theme.palette.grey[700],
      fontSize: 13,
      fontWeight: 600,
    },
    "& .MuiTableCell-body": {
      borderBottom: "unset",
      fontSize: 13,
      fontWeight: 500,
    },
  },
  waitToSyncIcon: {
    bottom: "-4px",
    position: "relative",
    margin: "0px 2px 0px 8px",
    animation: "spin 2s linear infinite",
    "@keyframes spin": {
      "0%": {
        transform: "rotate(360deg)",
      },
      "100%": {
        transform: "rotate(0deg)",
      },
    },
  },
  syncErrorIcon: {
    bottom: "-4px",
    position: "relative",
    marginLeft: "8px",
  },
};
